"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { withSlotScopeClasses } from '../../helpers/scoped-slots.mjs';
import { forwardRef, useId } from 'react';
import { tv } from 'tailwind-variants';
import { IconButton } from '../../ui-kit/icon-button.mjs';
import { SvgIcon } from '../SvgIcon/index.mjs';
import { preventFocusShift } from './utils.mjs';

const dropdownBackButtonRecipe = tv({
  slots: withSlotScopeClasses("dropdown-back-button", {
    container: "flex gap-2 items-center px-1.5 py-1",
    button: "h-6 w-6 min-w-[unset] rounded-md text-fg-muted data-[current]:bg-bg-muted",
    icon: "w-4 h-4",
    title: "font-medium text-fg-muted text-sm"
  })
});
const BackButton = forwardRef(
  ({ className, children, ...props }, ref) => {
    const { container, button, icon, title } = dropdownBackButtonRecipe();
    const id = useId();
    return /* @__PURE__ */ jsxs("div", { className: container(), children: [
      /* @__PURE__ */ jsx(
        IconButton,
        {
          ref,
          variant: "ghost",
          colorPalette: "gray",
          className: button({ className }),
          "aria-labelledby": id,
          onMouseDown: preventFocusShift,
          ...props,
          children: /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.ChevronLeft, className: icon() })
        }
      ),
      /* @__PURE__ */ jsx("span", { className: title(), id, children })
    ] });
  }
);

export { BackButton };
